import { Link } from "react-router-dom";
import { WHATSAPP_URL } from "@/lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
      <div className="px-4 sm:px-6 lg:px-12 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <img src="/logo.webp" alt="S'NO" className="h-12 w-auto mb-5" />
          <p className="text-sm text-zinc-400 leading-relaxed max-w-xs">
            Streetwear technique né dans les rues de Montréal, pensé pour la montagne.
            Ride the undercurrent.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mb-5">Navigation</p>
          <ul className="space-y-3">
            {[
              { to: "/", label: "Accueil" },
              { to: "/boutique", label: "Boutique" },
              { to: "/galerie", label: "Galerie" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="font-display uppercase tracking-widest text-lg text-zinc-300 hover:text-ice transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mb-5">Contact</p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-sm text-zinc-300 hover:text-ice transition-colors"
          >
            +1 514 826 0610
          </a>
          <p className="font-mono text-xs text-zinc-600 mt-3">CANADA — QC</p>
          <p className="font-mono text-xs text-zinc-600 mt-6">
            Paiement sécurisé : Stripe / PayPal
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 px-4 sm:px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600">
          © 2026 S'NO — Tous droits réservés
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600">
          FW26 Drop / Ride the undercurrent
        </p>
      </div>
    </footer>
  );
}
